import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { Dispatch, FC, SetStateAction, useContext, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { DeleteIcon } from '../../vectors/index';
import { Application } from '@features/applications';
import { Delete } from '@mui/icons-material';
import { useDeleteSpecificInterview } from '@features/applications/hooks/useDeleteSpecificInterview';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';

type DeletInterviewModalProps = {
  isShowDeleteInterviewModal: boolean;
  handleClose: () => void;
  setApplicationData?: Dispatch<SetStateAction<Application[] | null>>;
  setApplication?: Dispatch<SetStateAction<Application | null>>;
  application: Application;
  selectedCompanyId?: string | number;
};

const DeletInterviewModal: FC<DeletInterviewModalProps> = ({
  isShowDeleteInterviewModal,
  handleClose,
  setApplicationData,
  setApplication,
  application,
  selectedCompanyId,
}) => {
  const [errorText, setErrorText] = useState('');
  const { deleteInterview, isDeletingInterview } = useDeleteSpecificInterview({
    setErrorText,
  });

  const handleDelete = () => {
    const options = {
        onSuccess: (data: {
            status: number; objects: Application }) => {
        if (data.status === 200) {
          toast.success('Interview deleted successfully');
            handleClose();
          if (setApplication) {
              setApplication(data.objects);
          }
          if (setApplicationData) {
            setApplicationData((prev) => {
              if (prev) {
                return prev.map((item) => {
                  if (item.id === data.objects.id) {
                    return data.objects;
                  }
                  return item;
                });
              }
              return prev;
            });
          }
        }
      },
    };
    deleteInterview(
      {
        application_id: application.id,
        ...(application?.calendar_block_invite
          ? { calendar_block_invite: application?.calendar_block_invite?.id }
          : {}),
        ...(application?.calendar_item
            ? { calendar_item: application?.calendar_item?.id }
          : {}),
      },
      options,
    );
  };
  return (
    <Dialog
      open={isShowDeleteInterviewModal}
      onClose={handleClose}
      maxWidth={'xs'}
      fullWidth
      disableEnforceFocus
    >
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <br />
        <DeleteIcon />
        <br />
        <Typography variant="h4" sx={{ p: 3 }}>
          Are you sure you want to delete this interview?
        </Typography>
      </DialogTitle>
      <DialogContent>
        {errorText && <Alert severity="error">{errorText}</Alert>}
        <Stack spacing={3}>
          <LoadingButton
            loading={isDeletingInterview}
            variant="contained"
            color="error"
            startIcon={<Delete />}
            onClick={handleDelete}
          >
            Delete
          </LoadingButton>
          <Button
            variant="outlined"
            onClick={handleClose}
            startIcon={<CloseIcon />}
          >
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DeletInterviewModal;
